import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { WidgetsDto } from 'src/models/widgets.dto';

import { API } from ':api';
import { WIDGETS_LIST_URL } from ':api/urls';

export type QueryType = {
  items: WidgetsDto[];
};

export const useWidgetsApi = (
  employeeNumber: string | undefined,
): UseQueryResult<QueryType> =>
  useQuery<QueryType>({
    queryKey: ['Widgets', employeeNumber],
    queryFn: async () => {
      const query = employeeNumber ? `employee_number=${employeeNumber}` : '';
      return (await API.get(`${WIDGETS_LIST_URL}?${query}`)).data;
    },
  });
